"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingPage = void 0;
var Advertising_1 = require("./Advertising");
Object.defineProperty(exports, "AdvertisingPage", { enumerable: true, get: function () { return Advertising_1.AdvertisingPage; } });
